export default __webpack_public_path__ + "assets/overcast-night.be323821.svg";